/**
 * Receive a string and format it to pass as
 * value in [data-test] variable with correct format.
 * @param value => Value to format
 * @returns String to pass
 */
export function getDataFormat(value: string) {
  if (!value) return '';

  return value.split(' ').join('-');
}

export default getDataFormat;
